const FirstTime = () => {
	return (
		<div class="container">
			<div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 bg-body-tertiary">
				<div class="p-lg-5 mx-auto my-3">
					<h2 class="display-3 fw-bold text-center">Poprvé</h2>
					<h3 class="fw-normal text-muted mb-3 mt-5">Co si vzít s sebou</h3>
					<ul class="bullet p-0">
						<li>Základem je pevná obuv, k další výbavě patří ochrana očí, maska, rukavice. Zakázáno je používání síťovaných brýlí! Pro hráče mladších 15 let je povinná ochrana celého obličeje (celo-obličejová maska nebo síťka na obličej + brýle )</li>
						<li>Doporučujeme celoobličejovou masku a rukavice, střety probíhají na vzdálenosti metrů.</li>
					</ul>
					<h3 class="fw-normal text-muted mb-3">Půjčujete vybavení?</h3>
					<ul class="bullet p-0">
						<li>Používáme převážně automatické zbraně typu G36C. Tyto zbraně jsou vybaveny poloautomatickými zásobníky (kapacita 580 a 460).</li>
						<li>Rovněž jsou k dispozici ochranné masky na obličej, žluté reflexní vesty, kuličky 0.25g a 0.28g, plyn nebo něco na zahnání hladu.</li>
					</ul>
					<h3 class="fw-normal text-muted mb-3">Mohou u nás hrát i neplnoletí hráči?</h3>
					<ul class="bullet p-0">
						<li>Ano, a to buď v doprovodu zákonného zástupce, nebo s sebou na hru musí přinést podepsaný formulář.</li>
					</ul>
					<h3 class="fw-normal text-muted mb-3">Jak u nás vypadá herní den?</h3>
					<ul class="bullet p-0">
						<li>Od 9:00 probíhá měření a registrace.</li>
						<li>V 10:00 začíná briefing, kde si projdeme pravidla (doporučujeme přijet už kolem 9:00, kdo nestihne registraci a měření včas hraje až další hru!). Následně jsou hráči rozděleni do 2 týmu.</li>
						<li>Poté se hraje z několika typů her: Team Death Match, Vlajka, Dobývání, ...</li>
						<li>Kolem 13:00 je obědová pauza.</li>
						<li>Celodenní hra končí kolem 16:00 hod.</li>
					</ul>
					<h3 class="fw-normal text-muted mb-3">Kde se hraje?</h3>
					<ul class="bullet p-0">
						<li>Nově hra bude probíhat v areálu Bývalé Dynamitky Alfreda Nobela v Bohnicích.</li>
					</ul>
					<h3 class="fw-normal text-muted mb-3">Jak se k nám dostanete?</h3>
					<ul class="bullet p-0">
						<li>MHD: zastávka Zámky.</li>
						<li>Parkování: ul. U Drahaně, Praha 8.</li>
					</ul>
				</div>
				<div class="product-device shadow-sm d-none d-md-block"></div>
				<div class="product-device product-device-2 shadow-sm d-none d-md-block"></div>
			</div>
		</div>
	)
}

export default FirstTime